import React, { ButtonHTMLAttributes, FC, ReactElement } from 'react';

import { StyledButton } from './styles';

export const HelpButton: FC<ButtonHTMLAttributes<HTMLButtonElement>> = ({ onClick }): ReactElement => (
  <StyledButton onClick={onClick}>?</StyledButton>
);
